import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

// redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";
// import IKModal from "@Components/IkModal";
import Screen from "@Components/Screen";

// Utils
import dataHandler from "@Utils/dataHandler";
import { getExcludingNulls } from "@Utils/index";

// Modals Components
import ActionUserCrud from "./Modals/ActionUserCrud";
import FilterForm from "./Modals/FilterModal";

// Styles
import styles from "./styles.module.css";
import FilterBox from "../Monitor/Components/FilterBox";

// static data
import options from "./staticData";

const TableActionUser = ({ dispatch, userName, companyName }) => {
	const [, setTags] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const [checkAlllData, setCheckAllData] = useState([]);
	// const [selected, setSelected] = useState([]);
	const [workinFilterCount, setWorkingFilterCount] = useState(0);
	const [isWorkingActive, setIsWorkingActive] = useState(false);
	const [disconnetFilterCount, setDisconnetFilterCount] = useState(0);
	const [isDisconnetActive, setIsDisconnetActive] = useState(false);
	const [notWorkingFilterCount, setNotWorkingFilterCount] = useState(0);
	const [isNotWorkingActive, setIsNotWorkingActive] = useState(false);
	const [allFilterCount, setAllFilterCount] = useState(0);
	const [isAllActive, setIsAllActive] = useState(false);

	const [isOpenModal, setIsOpenModal] = useState(false);
	const [tableValue, setTableValue] = useState({});
	const [openFilter, setOpenFilter] = useState(false);
	const [agent, setAgent] = useState("");
	const [estado, setEstado] = useState([]);
	const today = new Date().toISOString().split("T")[0];
	const [fechaEstado, setFechaEstado] = useState(today);

	const defaultParams = { page: 1, orderKey: "lastLog.startDate", orderDir: "desc", rows: 20 };
	const [lastParams, setLastParams] = useState(defaultParams);

	useEffect(() => {
		(async () => {
			const companyUsersPromese = await dataHandler({
				dispatch,
				url: "companyUsers",
				params: { ...lastParams, "lastLog.startDate": today },
			});

			setFilteredCount(companyUsersPromese.count);
			setFilteredItems(companyUsersPromese.items);
			setLastParams({ ...lastParams, "lastLog.startDate": `${today},` });
			getCountFilter(companyUsersPromese.counts);
			setIsAllActive(true);
		})();
	}, []);

	// Table handlers
	const handlerData = async (params, printable, findAll, isCheck = false) => {
		const data = await dataHandler({ dispatch, url: "companyUsers", params: { ...lastParams, ...params } });
		if (!isCheck && !printable) {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setTableValue(data.items);
			getCountFilter(data.counts);
		}
		if (printable) {
			setFilteredPrintData(data.items);
			getCountFilter(data.counts);
		}

		if (findAll) {
			setCheckAllData(data.items);
			getCountFilter(data.counts);
		} else {
			setCheckAllData([]);
		}
	};

	const getCountFilter = (data) => {
		setAllFilterCount(getExcludingNulls(data, "total", 0));
		setWorkingFilterCount(getExcludingNulls(data, "trabajando", 0));
		setDisconnetFilterCount(getExcludingNulls(data, "desconectado", 0));
		setNotWorkingFilterCount(getExcludingNulls(data, "sinTrabajar", 0));
	};

	const onFilter = async (params) => {
		const updatedParams = { ...lastParams };

		Object.keys(params).forEach((key) => {
			let value = params[key];

			if (value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) {
				delete updatedParams[key];
			} else {
				if (key === "lastLog.startDate" && typeof value === "string") {
					value = `${value},`;
				}
				updatedParams[key] = value;
			}
		});

		const finalParams = isEmpty(updatedParams) ? defaultParams : updatedParams;

		const companyUsersPromese = await dataHandler({
			dispatch,
			url: "companyUsers",
			params: finalParams,
		});

		setFilteredCount(companyUsersPromese.count);
		setFilteredItems(companyUsersPromese.items);
		getCountFilter(companyUsersPromese.counts);
		setLastParams(finalParams);
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				setIsOpenModal(true);
				setTableValue(item);
				break;
			case "onClick":
				setTags(item);
				break;

			default:
				break;
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const getDataState = async (params) => {
		const data = await dataHandler({
			dispatch,
			url: "companyUsers",
			params,
		});

		setFilteredItems(data.items);
		setFilteredCount(data.count);

		return { data: data.items, count: data.count, counts: data.counts };
	};

	const handleBoxClick = async (state) => {
		let newParams = { ...lastParams, state };

		switch (state) {
			case "Trabajando":
				{
					newParams = { ...lastParams, "lastLog.state": ["En Línea", "No Asigna Chat"] };
					const newResult = await getDataState(newParams);
					setWorkingFilterCount(newResult.count);
					setIsWorkingActive(true);
					setIsDisconnetActive(false);
					setIsNotWorkingActive(false);
					setIsAllActive(false);
				}
				break;
			case "Desconectado":
				{
					newParams = { ...lastParams, orderDir: "asc", orderKey: "lastLog.startDate", "lastLog.state": ["Desconectado"] };
					const newResult = await getDataState(newParams);
					setDisconnetFilterCount(newResult.count);
					setIsDisconnetActive(true);
					setIsWorkingActive(false);
					setIsNotWorkingActive(false);
					setIsAllActive(false);
				}
				break;

			case "Sin Trabajar":
				{
					newParams = {
						...lastParams,
						orderDir: "asc",
						orderKey: "lastLog.startDate",
						"lastLog.state": ["Almuerzo", "Break", "Gestión Interna", "Baño", "En Reunión", "No Asigna Chat"],
					};
					const newResult = await getDataState(newParams);
					setNotWorkingFilterCount(newResult.count);
					setIsNotWorkingActive(true);
					setIsWorkingActive(false);
					setIsDisconnetActive(false);
					setIsAllActive(false);
				}
				break;
			default:
				{
					const newResult = await getDataState({ ...lastParams });
					setAllFilterCount(newResult.count);
					setIsAllActive(true);
					setIsWorkingActive(false);
					setIsDisconnetActive(false);
					setIsNotWorkingActive(false);
				}
				break;
		}
	};

	const handleChangeOption = () => {
		setOpenFilter(true);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Estado Agente">
			<div className={styles.grid}>
				<div className={styles.filterContainer}>
					<div className={styles.filterBox}>
						<FilterBox
							title="En Línea"
							count={workinFilterCount}
							isSelected={isWorkingActive}
							className={styles.contentBox}
							position="left"
							onClick={() => {
								return handleBoxClick("Trabajando");
							}}
						/>
						<FilterBox
							title="Desconectado"
							count={disconnetFilterCount}
							isSelected={isDisconnetActive}
							className={styles.contentBox}
							position="centerLeft"
							onClick={() => {
								return handleBoxClick("Desconectado");
							}}
						/>
						<FilterBox
							title="Sin Trabajar"
							count={notWorkingFilterCount}
							isSelected={isNotWorkingActive}
							className={styles.contentBox}
							position="centerRight"
							onClick={() => {
								return handleBoxClick("Sin Trabajar");
							}}
						/>

						<FilterBox
							title="Todos"
							count={allFilterCount}
							isSelected={isAllActive}
							className={styles.contentBox}
							position="right"
							onClick={() => {
								return handleBoxClick();
							}}
						/>
					</div>
				</div>

				<IkTable
					data={filteredItems}
					hidePrintButtons
					columns={[
						{
							label: "Grupo",
							key: "groups,name",
							format: "arrayTruncate",
							headerPosition: "left",
							width: 1,
						},
						{
							label: "Agente",
							key: "user.fullName",
							format: "string",
							headerPosition: "left",
							width: 2,
						},
						{
							label: "Estado",
							key: "lastLog.state",
							format: isWorkingActive ? "string" : "colorLabel",
							headerPosition: "left",
							width: 2,
						},
						{
							label: "Inicio",
							key: "lastLog.startDate",
							format: "dateTime",
							headerPosition: "left",
							width: 2,
						},
						{
							label: "Transcurrido",
							key: "lastLog.startDate",
							format: "timeBetween",
							dataPosition: "left",
							headerPosition: "left",
							width: 2,
						},
						{
							label: "Chats",
							key: "user.count",
							format: "string",
							headerPosition: "left",
							canFilter: false,
							canSort: false,
							width: 15,
						},
					]}
					handlerTable={handleButtom}
					mobileCardView
					cardLine1={[
						{ label: "", key: "user.fullName" },
						{ label: "Estado", key: "lastLog.state" },
						{ label: "Chats", key: "user.count" },
					]}
					cardLine2={[{ label: "Transcurrido", key: "lastLog.startDate", format: "timeBetween" }]}
					totalRows={filteredCount}
					defaultParams={lastParams}
					dataHandler={handlerData}
					filteredPrintData={filteredPrintData}
					searcher={{
						searchable: true,
						searchPosition: "flex-start",
						searchDisabled: false,
						filterButton: false,
						width: "40rem",
					}}
					topButtons={[
						{
							componentType: "Button",
							content: "Filtrar",
							icon: "filter",
							buttonContainerStyle: styles.filterButton,
							onClick: handleChangeOption,
							className: styles.buttonFilterTable,
						},
						{
							icon: "refresh",
							className: styles.refreshButton,
							onClick: () => {
								handleRefreshData();
							},
						},
					]}
					checkAllData={checkAlllData}
					print={{ printHeader: { company: companyName, title: "Estado Agente", user: userName } }}
				/>
			</div>
			{isOpenModal && (
				<ActionUserCrud
					companyName={companyName}
					userName={userName}
					tableValue={tableValue}
					// refresh={refresh}
					onClose={() => {
						setIsOpenModal(false);
					}}
					newParams={lastParams}
					// modalCrud={modalOption
				/>
			)}

			{openFilter && (
				<FilterForm
					onClose={() => {
						setOpenFilter(false);
					}}
					onFilter={onFilter}
					agent={agent}
					setAgent={setAgent}
					estado={estado}
					setEstado={setEstado}
					fechaEstado={fechaEstado}
					setFechaEstado={setFechaEstado}
					stateOptions={options}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		user,
		userName: user.name,
		companyName: company.name,
		// companySettings: company.settings,
	};
}

TableActionUser.propTypes = {
	dispatch: PropTypes.func,
	// chatCurrent: PropTypes.object,
	userName: PropTypes.string,
	companyName: PropTypes.string,
};
export default connect(mapStateToProps)(TableActionUser);
